import { connect } from 'react-redux';
import { push } from 'react-router-redux';

// components
import CommentList from './CommentList';

// selectors
import getOrganization from '../../lib/selectors/getOrganization';

// helpers
import getPathWithSearch from '../../helpers/getPathWithSearch';

const mapStateToProps = state => ({
  pnm:                  state.get('pnm'),
  round:                state.get('round'),
  currentChapter:       state.get('currentChapter'),
  currentUser:          state.get('currentUser'),
  allowAnonymousVoting: getOrganization(state).get('allowAnonymousVoting', false),
});

const mapDispatchToProps = dispatch => ({
  navigate: (route, queryParams = {}) => {
    dispatch(push(getPathWithSearch(route, queryParams)));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CommentList);
